<i18n>
{
  "en": {
    "priceLegend": "Overridden price",
    "noPriceLegend": "The price has not been overridden",
    "specialLegend": "The product was set special in the menu",
    "rankLegend": "The product's position was set first"
  },
  "es": {
    "priceLegend": "Precio sobreescrito",
    "noPriceLegend": "Precio no sobreescrito",
    "specialLegend": "Producto especial en menú",
    "rankLegend": "Producto en primera posición del menú"
  }
}
</i18n>
<template>
  <dynameat-info-modal>
    <div class="d-grid custom-grid py-4">
      <v-chip medium class="mx-1 grid-start-y grid-center-x" >
        <div class="price-text">15€</div>
      </v-chip>
      <div class="grid-center-y">{{ $t('priceLegend') }}</div>
      <v-chip medium class="mx-1 grid-start-y grid-center-x">
        <v-icon medium>mdi-currency-eur-off</v-icon>
      </v-chip>
      <div class="grid-center-y">{{ $t('noPriceLegend') }}</div>
      <v-chip medium class="mx-1 grid-start-y grid-center-x">
        <v-icon medium>mdi-star</v-icon>
      </v-chip>
      <div class="grid-center-y">{{ $t('specialLegend') }}</div>
      <v-chip medium class="mx-1 grid-start-y grid-center-x">
        <div class="price-text">#1</div>
      </v-chip>
      <div class="grid-center-y">{{ $t('rankLegend') }}</div>
    </div>
  </dynameat-info-modal>
</template>

<script>
import DynameatInfoModal from '@dynameat/components/DynameatInfoModal';
import Vue from 'vue';
import Component from 'vue-class-component';
import { Components } from '@core/helpers/decorators';

@Component
@Components({ DynameatInfoModal })
export default class ProductBoostLegend extends Vue {
}
</script>

<style scoped>
.price-text {
  font-size: 15px;
  color: #545454;
  font-weight: bold;
}

.custom-grid {
  grid-template-columns: 70px auto;
  row-gap: 5px;

}
</style>
